<div [style.display]="dataLoading ? 'block' : 'none'" class="text-center" style="margin-top: 50px;">
    <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
</div>
@if (!dataLoading) {
    <div class="container">
        <div class="single-column-layout">
            <h1>Teams</h1>
            <table class="roles table table-striped table-hover table-condensed" style="line-height: 1.428">
                <tr>
                    <th style="width: 40%; text-transform: uppercase;">Team Name</th>
                    <th style="width: 42%; text-transform: uppercase;">Practice Area</th>
                    <th style="width: 10%; text-transform: uppercase;">Cost Center</th>
                    <th></th>
                </tr>
                @for (team of teams; track team) {
                    <tr [class.row-error]="team.isEditing && showUniqueTeamNameError">
                        <td [class.has-error]="team.isEditing && showUniqueTeamNameError">
                            @if (!team.isEditing) {
                                <span>
                                    {{ team.name }}
                                </span>
                            }
                            @if (team.isEditing) {
                                <input type="text"
                                       class="form-control"
                                       [(ngModel)]="team.name"
                                       required
                                       maxlength="100"/>
                            }
                            @if (team.isEditing && showUniqueTeamNameError) {
                                <span class="text-danger">Must be unique</span>
                            }
                        </td>
                        <td>
                            @if (!team.isEditing) {
                                <span>
                                    {{ team.practiceArea }}
                                </span>
                            }
                            @if (team.isEditing) {
                                <input type="text" class="form-control" [(ngModel)]="team.practiceArea"
                                       maxlength="100"/>
                            }
                        </td>
                        <td>
                            @if (!team.isEditing) {
                                <span>
                                    {{ team.costCenter }}
                                </span>
                            }
                            @if (team.isEditing) {
                                <input type="text" class="form-control" [(ngModel)]="team.costCenter"
                                       maxlength="50"/>
                            }
                        </td>
                        <td style="white-space: nowrap">
                            <span>&nbsp;
                                @if (hasTeamEditPermissions) {
                                    <span>
                                        @if (team.isEditing) {
                                            <span class="">
                                                <button type="button"
                                                        class="ace-btn has-icon btn-primary btn-success"
                                                        tooltip="Save"
                                                        (click)="saveTeam(team)"
                                                        [disabled]="!team.name  || team.name.length === 0">
                                                    <i class="fa fa-save"></i>
                                                </button>
                                                <button type="button"
                                                        (click)="cancelEdit(team)"
                                                        class="ace-btn has-icon btn-primary btn-danger"
                                                        tooltip="Cancel">
                                                    <i class="fa fa-close"></i>
                                                </button>
                                            </span>
                                        }
                                        @if (!team.isEditing) {
                                            <span class="buttons">
                                                <button class="ace-btn has-icon btn-primary" (click)="enableEdit(team)"
                                                        tooltip="Edit" [disabled]="editMode">
                                                    <i class="fa fa-pencil"></i>
                                                </button>
                                                @if (!team.isDeleting) {
                                                    <button class="ace-btn has-icon btn-primary btn-danger"
                                                            (click)="deleteTeam(team, unableToDeleteTemplate)"
                                                            tooltip="Delete"
                                                            [disabled]="editMode">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                }
                                                @if (team.isDeleting) {
                                                    <ws-ace-loader [inline]="true"></ws-ace-loader>
                                                }
                                            </span>
                                        }
                                    </span>
                                }
                            </span>
                        </td>
                    </tr>
                }
            </table>
            @if (hasTeamEditPermissions) {
                <button class="ace-btn btn-primary" (click)="addTeam()" [disabled]="editMode"
                >Add Team
                </button>
            }
        </div>
    </div>
}

<ng-template #unableToDeleteTemplate>
    <ws-modal-wrapper headerLabel="Unable to Delete Team"
                      [hideFooter]="true"
                      [loading]="teamMembersLoading"
                      (cancel)="unableToDeleteRef.hide()">
        @if (!teamMembersLoading) {
            <div>
                Cannot delete a team with existing users. To delete, please remove the following users from this team:
                <ul>
                    @for (user of teamMembers; track user) {
                        <li>
                            {{ user.firstName }} {{ user.lastName }}
                        </li>
                    }
                </ul>
            </div>
        }
    </ws-modal-wrapper>
</ng-template>
